import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useRef, useContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;
import Switch from "react-bootstrap-switch";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const BandwidthEdit = () => {
  const history = useHistory();
  const location = useLocation();
  let formError = false;

  // Object containing all the form values
  const [values, setValues] = useState({
    description: "",
    downstream: 0,
    name: "",
    upstream: 0,
    enforce: false,
  });

  // Object containing all error messages for every inputs
  const [bandwidthStates, setBandwidthStates] = useState({
    description: "",
    downstream: "",
    name: "",
    upstream: "",
    enforce: "",
  });

  const [params, setParams] = useState(location.state?.value ?? "");
  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.bandwidths.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    if (mode == "edit") {
      fetchEditData();
    } else if (mode == "create") {
      fetchCreateData();
    }
  }, [mode]);

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    // Validate all the field before calling the API
    if (mode == "create") {
      setBandwidthStates({
        ...bandwidthStates,
        ["downstream"]: validateField("downstream"),
        ["name"]: validateField("name"),
        ["upstream"]: validateField("upstream"),
      });
    } else if (mode == "edit") {
      setBandwidthStates({
        ...bandwidthStates,
        ["downstream"]: validateField("downstream"),
        ["name"]: validateField("name"),
        ["upstream"]: validateField("upstream"),
      });
    }

    if (!formError) {
      postData();
    }
  };

  const redirectToBandwidthList = (success, warnings) => {
    const location = {
      pathname: "/admin/bandwidths/list",
      state: {
        warningMsg: warnings,
        successMsg: success,
      },
    };
    history.push(location);
  };

  // Validate if field is empty
  const validateField = (field) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const fetchCreateData = () => {
    fetch("/api/v1/bandwidth/create", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchEditData = () => {
    setShowLoading(true);
    const start = Date.now();

    fetch("/api/v1/bandwidth/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        id: params,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          setValues(actualData.data);
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "";
    let apiMethod = "";
    if (mode == "edit") {
      apiUrl = "/api/v1/bandwidth/edit";
      apiMethod = "PUT";
    } else if (mode == "create") {
      apiUrl = "/api/v1/bandwidth/create";
      apiMethod = "POST";
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        description: values.description,
        downstream: values.downstream,
        name: values.name,
        upstream: values.upstream,
        bandwidth_id: params,
        enforce: values.enforce,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        var redirectToList = true;
        if (actualData.error_code) {
          redirectToList = false;
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while saving the bandwidth", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Bandwidth saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }

        // If a bandwidth is created successfully, switch to edit mode on the same bandwidth
        if (redirectToList) {
          redirectToBandwidthList(
            actualData.warning_code ? "" : "Bandwidth saved successfully",
            actualData.warning_code,
          );
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/bandwidths/list",
                      }}
                    >
                      Bandwidths
                    </NavLink>
                    {params.includes("bandwidth") ? (
                      <i>&lt;{params.split("||")[1]}&gt;</i>
                    ) : (
                      ""
                    )}
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    {mode == "create" ? "Create" : ""}
                    {mode == "edit" ? "Edit" : ""}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Bandwidth Information</CardTitle>
              </CardHeader>
              <CardBody>
                {Array.isArray(errorMsg) && errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>Name</label>
                      <FormGroup
                        className={
                          bandwidthStates["name"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter name"
                          type="text"
                          name="name"
                          onChange={handleInputChange}
                          value={values ? values.name : ""}
                        />
                        <label className="error">
                          {bandwidthStates["name"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <>
                        <label>Description</label>
                        <FormGroup
                          className={
                            bandwidthStates["description"].length !== 0
                              ? "has-danger"
                              : ""
                          }
                        >
                          <Input
                            placeholder="Enter description"
                            type="text"
                            name="description"
                            onChange={handleInputChange}
                            value={values ? values.description : ""}
                          />
                          <label className="error">
                            {bandwidthStates["description"]}
                          </label>
                        </FormGroup>
                      </>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <>
                        <label>Downstream Bandwidth</label>
                        <FormGroup
                          className={
                            bandwidthStates["downstream"].length !== 0
                              ? "has-danger"
                              : ""
                          }
                        >
                          <Input
                            type="number"
                            name="downstream"
                            onChange={handleInputChange}
                            value={values ? values.downstream : 0}
                          />
                          <label className="error">
                            {bandwidthStates["downstream"]}
                          </label>
                        </FormGroup>
                      </>
                    </Col>
                    <Col>
                      <label>Upstream Bandwidth</label>
                      <FormGroup
                        className={
                          bandwidthStates["upstream"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          type="number"
                          name="upstream"
                          min="0"
                          onChange={handleInputChange}
                          value={values ? values.upstream : 0}
                        />
                        <label className="error">
                          {bandwidthStates["upstream"]}
                        </label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {mode == "edit" ? (
                    <Row>
                      <Col>
                        <label className={"settingLabel"}>Enforce</label>
                        <FormGroup>
                          <Switch
                            name="enforce"
                            offColor="success"
                            offText={<i className="nc-icon nc-simple-remove" />}
                            onColor="success"
                            onText={<i className="nc-icon nc-check-2" />}
                            onChange={(event) =>
                              Utilities.handleSwitchChange(
                                event,
                                values,
                                setValues,
                              )
                            }
                            value={values["enforce"] ? true : false}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BandwidthEdit;
